import { Component, OnInit, ViewChild } from '@angular/core';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { normalizarValorOrdenacao } from '../../../../shared/helpers/ordenacao-tabela.helper';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { ConfirmModalComponent } from '../../../../shared/components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { ReturnStruct } from '../../../../shared/services/structs/return.struct';
import { RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../../shared/components/empty-list/empty-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { UtilService } from '../../../../shared/services/util.service';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { ListaPrecoService } from '../../../../shared/services/apis/produto/lista-preco.service';
import { GetListaPrecoResponse } from '../../../../shared/services/responses/produto/get-lista-preco.response';
import { ListaPrecoPesquisaStruct } from '../../../../shared/services/structs/produto/lista-preco-pesquisa.struct';
import { ListaPrecoBulkDeleteRequest } from '../../../../shared/services/requests/produto/lista-preco-bulk-delete.request';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LoadingBoxDefaultListComponent } from '../../../../shared/components/loading-box-default-list/loading-box-default-list.component';


@Component({
    selector: 'app-lista-preco-lista',
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        CommonModule,
        MatTableModule,
        RouterModule,
        EmptyListComponent,
        MatTooltipModule,
        MatMenuModule,
        MatSortModule,
        HeaderComponent,
        MatCheckboxModule,
        LoadingBoxDefaultListComponent
    ],
    templateUrl: './config-lista-preco.component.html',
    styleUrl: './config-lista-preco.component.css',
})
export class ConfigListaPrecoComponent implements OnInit {
    public moduloEnum: ModuloEnum;
    public funcionalidadeEnum: FuncionalidadeEnum;

    @ViewChild(MatSort) set matSort(sort: MatSort) {
        this._dataSource.sort = sort;
        this._dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'descricao': return normalizarValorOrdenacao(item.descricao);
                default: return normalizarValorOrdenacao((item as any)[property]);
            }
        };
    }

    constructor(
        private formBuilder: FormBuilder,
        private listaPrecoService: ListaPrecoService,
        private alertService: AlertService,
        private dialog: MatDialog,
        private utilService: UtilService
    ) {
        this.moduloEnum = ModuloEnum.Configuracoes;
        this.funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Cadastros;
    }

    public model: FormGroup;
    public _isLoading: boolean = false;
    public _listaPrecoResponse: GetListaPrecoResponse | undefined;
    public displayedColumns: string[] = ['select', 'descricao', 'dataInicioVigencia', 'dataTerminoVigencia', 'metodoAjustePreco', 'isPromocao', 'actions'];
    public _dataSource = new MatTableDataSource<ListaPrecoPesquisaStruct>();
    public _paginaAtual: number = 1;
    public _ultimaPagina: boolean = false;
    public selection = new SelectionModel<ListaPrecoPesquisaStruct>(true, []);

    ngOnInit(): void {
        this.model = this.formBuilder.group({
            pesquisa: [''],
        });

        this.loadFilters();
        this.pesquisar();
    }

    ngOnDestroy(): void {
        this.utilService.salvarFiltro(this.moduloEnum, this.funcionalidadeEnum, this.model, ['/configuracoes/cadastros/lista-precos/cadastrar']);
    }

    private loadFilters() {
        const filtroSalvo = this.utilService.obterFiltro(this.moduloEnum, this.funcionalidadeEnum);
        if (filtroSalvo) {
            this.model.patchValue(filtroSalvo);
        }
    }

    private pesquisar(): void {
        if (this._isLoading == true) {
            return;
        }

        this._isLoading = true;
        const pesquisa: string = this.model.get('pesquisa')?.value;

        this.listaPrecoService.getAll(pesquisa, this._paginaAtual).subscribe({
            next: (response: GetListaPrecoResponse) => {
                this._isLoading = false;
                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                    return;
                }

                this._ultimaPagina = true;

                if (!this._listaPrecoResponse) {
                    this._listaPrecoResponse = response;
                    this._ultimaPagina = false;
                } else if (response.listaPrecos?.length > 0) {
                    this._listaPrecoResponse.listaPrecos.push(...response.listaPrecos);
                    this._ultimaPagina = false;
                }

                this._dataSource.data = this._listaPrecoResponse.listaPrecos;
                this.selection.clear();
            },
            error: error => {
                this.alertService.show('Erro inesperado', error, AlertType.error);
                console.log(error);
                this._isLoading = false;
            },
        });
    }

    proximaPagina(): void {
        this._paginaAtual = this._paginaAtual + 1;
        this.pesquisar();
    }

    clickPesquisar(): void {
        this._paginaAtual = 1;
        this._listaPrecoResponse = undefined;
        this.pesquisar();
    }


    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this._dataSource.data.filter(x => !x.isPadrao).length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this._dataSource.data.forEach(row => {
                if (!row.isPadrao) this.selection.select(row);
            });
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: ListaPrecoPesquisaStruct): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.idListaPreco + 1}`;
    }

    abrirModalExcluir(id: number, nome: string): void {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Alerta',
                description: `Deseja excluir a lista de preços "${nome}"?`,
                buttonConfirm: 'Confirmar',
                buttonClose: 'Cancelar',
            },
        });

        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result && result.confirm) {
                    this.excluir([id]);
                }
            },
        });
    }

    abrirModalExcluirEmMassa(): void {
        const dialogRef = this.dialog.open(ConfirmModalComponent, {
            data: {
                title: 'Confirmação',
                description: `Confirma a exclusão das listas de preços selecionadas?`,
                buttonConfirm: 'Confirmar',
                buttonClose: 'Cancelar',
            },
        });

        dialogRef.afterClosed().subscribe({
            next: result => {
                if (result && result.confirm) {
                    const ids = this.selection.selected.map(item => item.idListaPreco);
                    this.excluir(ids);
                }
            }
        });
    }

    private excluir(ids: number[]): void {
        this._isLoading = true;
        const request = new ListaPrecoBulkDeleteRequest();
        request.idsListaPreco = ids;

        this.listaPrecoService.excluir(request).subscribe({
            next: (response) => {
                this._isLoading = false;

                if (response.isError) {
                    this.alertService.show('Erro', response.errorDescription, AlertType.error);
                } else {
                    this.alertService.show('Sucesso', 'Lista(s) de preços excluída(s) com sucesso', AlertType.success);
                    this.clickPesquisar();
                }
            },
            error: (error) => {
                this.alertService.show('Erro inesperado', error, AlertType.error);
                this._isLoading = false;
            }
        });
    }
}
